import { clsx } from 'clsx'
import { observer } from 'mobx-react-lite'
import { ReactNode } from 'react'
import { opt } from 'store/opt'
import css from './InferenceList.module.scss'

type Props = {
  children: ReactNode
}

export const InferenceList = observer(({ children }: Props) => {
  return <div className={clsx(css.list, opt.stand && css.stand)}>
    {children}
  </div>
})
